import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root{
    --font-family: 'Open Sans', sans-serif;

    /* Colors */
    --app-background-color: #424242;
    --white: #FFFFFF;
    --gainsboro: #FAFAFA;
    --tertiary: #EAF6FE;
    --dark-blue: #12004A;
    --primary: #3251EA;
    --slate-gray: #495F6E;
    --gray: #A2A1A1;
    --dark-gray: #293039;
  }

  @page {
    size: A4;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  html {
    font-size: 62.5% !important;
  }

  body {
    font-size: 1.2rem;
    /* position: relative; */

    font-family: var(--font-family);
  }

  html, body, #root {
    height: 100%;
  }

  body, html {
    background-color: var(--app-background-color);
    font-family: var(--font-family);
  }

  .page {
    margin: 0 auto;
    margin-bottom: 0.846cm;

    &:first-child {
      margin-top: 0.846cm;
    }

    @media print {
      margin: 0 !important;
    }
  }
`;

const ContainerDefault = styled.div`
  width: 100%;
  // Comprimento de um papel A4
  max-width: 21cm;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  margin: 0 auto;

  @media print {
    max-width: 21cm;
    margin: 0;

    display: flex;
    align-items: stretch;
    justify-content: stretch;
    flex-direction: column;
  }
`;

export {
  // estilo global
  GlobalStyle,
  // Container
  ContainerDefault,
};
